import { AgGridColumnDef } from '@tassat/common-definitions';

export const ApiConnectionUsersColumnDefs: AgGridColumnDef[] = [
    {
        field: 'user.FirstName',
        headerName: 'First Name',
        menuTabs: ['filterMenuTab'],
        sort: 'asc',
        flex: 1
    },
    {
        field: 'user.LastName',
        headerName: 'Last Name',
        menuTabs: ['filterMenuTab'],
        sort: 'asc',
        flex: 1
    },
    {
        field: 'user.Username',
        headerName: 'Username',
        menuTabs: ['filterMenuTab'],
        flex: 1
    },
    {
        field: 'apiUser.APIConfirmCode',
        headerName: 'API Confirm Code',
        menuTabs: ['filterMenuTab'],
        flex: 1
    },
    {
        field: 'Firm.Name',
        headerName: 'Firm Name',
        menuTabs: ['filterMenuTab'],
        flex: 1
    },
    {
        field: 'apiUser',
        headerName: 'Actions',
        maxWidth: 150,
        cellRenderer: 'actionButtonsCellRenderer',
        cellRendererParams: {
            actionButtonOptions: {
                hasDelete: true,
                hasLock: true
            }
        },
        menuTabs: [],
        flex: 1
    }
];